import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-cream text-ink" data-id="element-61" data-mp="1lc1yr8r0kvp2">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-6 lg:py-24" data-id="element-62" data-mp="1gd7iadgirj84">
        <h2 className="text-center font-display text-[2rem] font-semibold text-brown sm:text-4xl" data-id="element-63" data-mp="1gauuhjo2yen5">
          Preguntas frecuentes
        </h2>

        <div className="mx-auto mt-10 max-w-2xl divide-y divide-gold/25 border-y border-gold/25" data-id="element-64" data-mp="292eg1a85g4sb">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-65" data-mp="1z3yml0lngjfn" data-mpi={index}>
                <h3 data-id="element-66" data-mp="1z2xdh1o7270k">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 py-5 text-left font-sans text-[0.98rem] font-semibold text-brown transition-colors duration-150 ease-out hover:text-rose-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-deep" data-id="element-67" data-mp="1z5jm74mtmskd">
                    {faq.question}
                    <PlusIcon aria-hidden="true" className={`mt-0.5 h-5 w-5 flex-none text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-68" data-mp="fiqem681suu4" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-69" data-mp="6pvic20k69gh">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-70" data-mp="bioo8t7rjnu5">
                      <p className="pb-5 pr-9 font-sans text-[0.95rem] leading-relaxed text-ink-soft" data-id="element-71" data-mp="3nyifoipzisdi">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}